import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import { Button, Divider, useMediaQuery } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { $authHost } from 'app/configs/axiosConfig';
import { useSnackbar } from 'notistack';
import { getAppStage } from '../hooks/getAppStage';
import useNorthDialogStore from '../store/northDialogSlice';
import './NorthButton.css';
import clsx from 'clsx';

export const numbersByStage = {
  development: '+18668651874',
  staging: '+18668651874',
  production: '+18447311359',
} as const;

export const appStage = getAppStage();
const phoneNumber = numbersByStage[appStage];

export function formatPhoneNumber(phoneNumberString: string) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

function NorthButton() {
  const { isOpen, openDialog, closeDialog } = useNorthDialogStore();
  const { enqueueSnackbar } = useSnackbar();
  const isMobile = useMediaQuery('(max-width: 960px)');

  return (
    <>
      <Button
        onClick={openDialog}
        className={clsx(
          ' mr-0 md:mr-16 flex items-center justify-center min-w-max overflow-hidden border-none p-2 rounded-[150px] sm:rounded-full',
          !isMobile && 'btn',
        )}
      >
        <span className="hover:bg-[#A6E22E] h-40 w-40 md:w-auto md:h-full transition-all duration-200 btnSpan flex items-center justify-center z-[1] rounded-[200px] text-black py-10 px-8 md:py-8 md:px-16 text-base bg-[#91D500] backdrop-blur-[40px] gap-10">
          <img
            className="w-[20px] h-[20px] svg-black"
            src="/assets/images/logo/north-icon.svg"
            alt="north-icon"
          />
          <span className="hidden md:inline">Speak to the Processor Now!</span>
        </span>
      </Button>

      <AppSimpleDialog
        open={isOpen}
        handleClose={closeDialog}
        title="Get a call from Processor"
        titleIcon={
          <img
            className="w-[25px] h-[25px]"
            src="/assets/images/logo/north-icon.svg"
            alt="north-icon"
          />
        }
        size="md"
        maxWidth="sm"
        scroll="paper"
      >
        <Divider />
        <DialogContent className="px-24">
          <div className="p-3 mt-10 flex flex-col items-center">
            <div className="w-[80px] h-[27px] mt-8">
              <img src="/assets/images/logo/north-logo.png" alt="north-logo" />
            </div>

            <h2 className="mt-8 font-bold text-3xl">Speak to someone now!</h2>
            <p className="mt-8 text-center">
              Call us directly at the phone number:{' '}
              <a
                className="blue-primary hover:blue-primary-hover font-[600]"
                href={`tel:${phoneNumber}`}
              >
                {formatPhoneNumber(phoneNumber)}
              </a>{' '}
              below or click the button to request a call.
            </p>
            <div className="mt-30 flex gap-14">
              <Button
                onClick={closeDialog}
                className="flex items-center text-gray-600 font-500 bg-gray-50 hover:bg-gray-200 px-16 py-8"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="text-white font-500 bg-blue-primary hover:bg-blue-primary-hover px-16 py-8 disabled:bg-gray-400 disabled:text-opacity-60"
                onClick={() => {
                  $authHost
                    .post('/merchant-callback-request')
                    .then((response) => {
                      closeDialog();
                      enqueueSnackbar('Callback request submitted successfully', {
                        variant: 'successToast',
                      });
                    })
                    .catch((error) => {
                      enqueueSnackbar('Failed to submit callback request', {
                        variant: 'errorToast',
                      });
                    });
                }}
              >
                Request a Callback
              </Button>
            </div>
          </div>
        </DialogContent>
      </AppSimpleDialog>
    </>
  );
}

export default NorthButton;
